import { render, staticRenderFns } from "./VerPlantilla.vue?vue&type=template&id=71fa3b2a&scoped=true"
import script from "./VerPlantilla.vue?vue&type=script&lang=js"
export * from "./VerPlantilla.vue?vue&type=script&lang=js"
import style0 from "./VerPlantilla.vue?vue&type=style&index=0&id=71fa3b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa3b2a",
  null
  
)

export default component.exports